var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ae89f6f84abcb65beeba27e8d4b5df2f2ec34731"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["qida-web@qida-tech"]={id:"ae89f6f84abcb65beeba27e8d4b5df2f2ec34731"};
      